<template>
    <div class="w-100 h-100 position-relative" @click="whenClick">
        <div id="video-cover" class="w-100 h-100 position-absolute">
            <video id="video" v-show="!tracked" class="fix-center" :style="videoStyle" ref="video"
                   preload autoplay loop muted/>
            <canvas id="canvas" v-show="!tracked" class="fix-center" :style="videoStyle"/>
        </div>
        <canvas id="face_canvas" v-show="tracked" class="fix-center" :style="videoStyle" ref="canvas"/>
        <div v-show="recognizeResult" class="recognize-footer">
            {{ recognizeResult }}
        </div>
    </div>
</template>

<script>

require('tracking/build/tracking-min')
require('tracking/build/data/face-min')

export default {
    name: "FaceRecognize",
    data() {
        return {
            trackingTask: null,
            tracked: false,
            camera: null,
            userMedia: null,
            recognizeResult: null,
            coverMinSize: 200,

            recognized: false,
        }
    },
    computed: {
        videoStyle() {
            return `width: ${this.coverMinSize}px; height: ${this.coverMinSize}px;`;
        },
    },
    mounted() {
        // this.startRecognize();
    },
    beforeDestroy() {
        this.closeVideo();
    },
    methods: {
        startRecognize() {
            let coverEl = document.getElementById('video-cover');
            if (coverEl) {
                this.coverMinSize = Math.min(coverEl.offsetHeight, coverEl.offsetWidth);
            }

            this.tracked = false;
            this.recognizeResult = null;
            this.recognized = false;

            const self = this;
            this.userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
            if (self.userMedia) {
                navigator.getUserMedia(
                    {video: {width: self.coverMinSize, height: self.coverMinSize}},
                    function (stream) {
                        self.camera = stream.getTracks()[0];
                        const video = document.getElementById("video");
                        video.srcObject = stream;

                        let gotFace = false;

                        let canvas = document.getElementById("face_canvas");
                        const trackingCanvas = document.getElementById('canvas');
                        const context = trackingCanvas.getContext('2d');

                        let x_rate = trackingCanvas.width / trackingCanvas.offsetWidth;
                        let y_rate = trackingCanvas.height / trackingCanvas.offsetHeight;

                        let tracker = new tracking.ObjectTracker('face');
                        tracker.setInitialScale(4);
                        tracker.setStepSize(2);
                        tracker.setEdgesDensity(0.1);
                        self.trackingTask = tracking.track('#video', tracker, {camera: true});

                        tracker.on('track', function (event) {

                            context.clearRect(0, 0, trackingCanvas.width, trackingCanvas.height);
                            event.data.forEach(function (rect) {
                                context.strokeStyle = "#a93df2";
                                context.strokeRect(rect.x * x_rate, rect.y * y_rate, rect.width * x_rate, rect.height * y_rate);
                            });

                            if (!gotFace && event.data.length) {
                                console.log("get face");
                                gotFace = true;
                                if (video.videoWidth === 0) {
                                    return;
                                }
                                // 让canvas和视频一样宽高。
                                let w = self.coverMinSize, h = self.coverMinSize;
                                canvas.width = w;
                                canvas.height = h;
                                // 把video标签中的画面，画到canvas中。
                                let ctx = canvas.getContext("2d");
                                ctx.drawImage(video, 0, 0, w, h);
                                // 把canvas中的图像转换成png图片文件的Base64字符串。
                                let imgStr = canvas.toDataURL("image/png").split("base64,")[1];
                                if (imgStr) {
                                    self.$store.dispatch("api/post",
                                        {
                                            url: self.$store.state.emAclUser.baseModuleUrl + "/emAclUser/face/recognize",
                                            data: imgStr
                                        },
                                        {root: true}
                                    ).then(response => {
                                      let result = response.data;
                                      if (result && result.success) {
                                        console.log("find user:" + result.name);
                                        self.closeVideo();
                                        self.$nextTick(() => self.tracked = true);
                                        self.$emit('user-identified', result.userInfo.id);
                                        self.recognizeResult = '当前用户：' + result.userInfo.name;
                                        self.recognized = true;
                                      } else {
                                        self.recognizeResult = result.msg;
                                        console.log("sleep 1s");
                                        setTimeout(function () {
                                          gotFace = false;
                                        }, 1000);
                                      }
                                    });
                                } else {
                                    gotFace = false;
                                }
                            }
                        });
                    },
                    function (err) {
                        console.log("The following error occurred: " + err.name);
                        self.camera.stop();
                    }
                );
            }
        },
        closeVideo() {
            if (this.trackingTask) {
                this.trackingTask.stop();
            }
            if (this.camera) {
                this.camera.stop();
            }
            window.mediaStreamTrack && window.mediaStreamTrack.stop();
            console.log('closed');
        },
        whenClick() {
            if (this.recognized) {
                this.startRecognize();
            }
        },
    },
}
</script>

<style scoped>
.recognize-footer {
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 50%);
    color: white;
    width: 100%;
    text-align: center;
}
</style>
